import { createEvent } from 'effector';

import { RequestDynamicFormState } from './RequestDynamicFormState';

export const requestDynamicFormEvent =
  createEvent<Partial<RequestDynamicFormState>>('requestDynamicFormEvent');
